import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, ChartsWrapper } from './LegalRateBenchmarks.styles';
import MinMaxAverageByRole from '../Charts/MinMaxAverageByRole';

const LegalRateBenchmarks = ({ setCurrentContent, label }) => {
	return (
		<>
			<Breadcrumbs>
				<span onClick={() => setCurrentContent(0)}>Category Widgets</span>&nbsp;/&nbsp;<span
				>
					{label}
				</span>
			</Breadcrumbs>
			<ChartsWrapper>
				<MinMaxAverageByRole chartTitle="Min, Max & Average By Role" />
			</ChartsWrapper>
		</>
	);
};

LegalRateBenchmarks.propTypes = {
	setCurrentContent: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
};

export default LegalRateBenchmarks;
